import { useQuery } from "@tanstack/react-query";
import { getClientProfile } from "@/integrations/backend/admin-users";
import { getClientChecklistItems } from "@/integrations/backend/checklist-items";
import { adminListClientFiles } from "@/integrations/backend/client-files";
import { adminGetEnabledGoalMetrics, listAvailableGoalMetrics } from "@/integrations/backend/goals";
import { CATALOG_STALE_BASE_MS, staleTimeWithJitterFromKey } from "@/lib/query-cache";
import { queryKeys } from "@/lib/query-keys";

export function useAdminClientProfileQuery(clientId: string) {
  const qk = queryKeys.admin.clients.profile(clientId);
  return useQuery({
    queryKey: qk,
    queryFn: () => getClientProfile(clientId),
    enabled: Boolean(clientId),
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...qk]),
  });
}

export function useAdminClientChecklistQuery(clientId: string) {
  const qk = queryKeys.admin.clients.checklistItems(clientId);
  return useQuery({
    queryKey: qk,
    queryFn: () => getClientChecklistItems(clientId),
    enabled: Boolean(clientId),
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...qk]),
  });
}

export function useAdminClientFilesQuery(clientId: string) {
  const qk = queryKeys.admin.clients.files(clientId);
  return useQuery({
    queryKey: qk,
    queryFn: () => adminListClientFiles(clientId),
    enabled: Boolean(clientId),
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...qk]),
  });
}

export function useGoalMetricsCatalogQuery() {
  const qk = queryKeys.goals.availableMetrics;
  return useQuery({
    queryKey: qk,
    queryFn: listAvailableGoalMetrics,
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...qk]),
  });
}

export function useAdminClientEnabledGoalMetricsQuery(clientId: string) {
  const qk = queryKeys.goals.adminEnabledMetrics(clientId);
  return useQuery({
    queryKey: qk,
    queryFn: () => adminGetEnabledGoalMetrics(clientId),
    enabled: Boolean(clientId),
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...qk]),
  });
}
